import { truthy } from "../util/util";
import * as React from "react";
class Dashlet extends React.Component {
    render() {
        const { className, title } = this.props;
        const classes = ["dashlet"].concat(className.split(" "));
        return (React.createElement("div", { className: classes.join(" ") },
            truthy(title) ? React.createElement("div", { className: "dashlet-title" }, title) : null,
            this.props.children));
    }
}
export default Dashlet;
